var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bigGift_svg__clip0_2637_11251)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.042 50.327c-3.062 3.19-7.912 3.898-12.01 2.647-4.555-1.392-8.173-4.855-10.825-8.718-1.638-2.388-2.983-4.965-4.253-7.567-.129-.262-.5-.334-.737-.195-.267.157-.322.477-.194.742 2.283 4.677 4.881 9.385 8.849 12.84 1.846 1.606 3.942 2.925 6.253 3.738a14.345 14.345 0 006.943.666c2.525-.386 4.954-1.53 6.736-3.386.482-.502-.278-1.269-.762-.767z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.54 34.37c1.227-.086 2.626-.213 3.77.345.886.432 1.618 1.264 1.567 2.264-.016.291.257.54.537.54.303 0 .524-.249.537-.54.07-1.336-.844-2.529-1.976-3.137-1.357-.728-2.95-.66-4.438-.556-.29.02-.537.234-.537.54 0 .279.247.562.537.541l.002.002z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.103 36.529a5.73 5.73 0 014.626.706c.585.377 1.126-.561.543-.934a6.811 6.811 0 00-5.455-.815c-.665.186-.383 1.23.286 1.045v-.002z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.526 38.594c1.27-1.005 3.24-1.534 4.771-.864.267.116.578.079.737-.195.132-.23.075-.624-.194-.741-2.028-.887-4.384-.305-6.076 1.034-.228.182-.188.575 0 .766.226.228.531.182.762 0z",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.134 33.346c.378.51.566 1.056.547 1.674a2.575 2.575 0 01-.586 1.52c-.188.221-.216.546 0 .766.194.195.572.224.762 0 1.074-1.269 1.215-3.147.205-4.506-.172-.233-.466-.353-.736-.195-.229.135-.369.506-.194.741h.002z",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.294 27.022h-56.38v56.726h56.38V27.022z",
    fill: "#FFDF4F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bigGift_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 27,
    width: 58,
    height: 57
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.294 27.022h-56.38v56.726h56.38V27.022z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bigGift_svg__a)",
    fill: "#FFEC9B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.808 100c10.925 0 19.78-8.91 19.78-19.903 0-10.991-8.855-19.902-19.78-19.902s-19.78 8.91-19.78 19.902S60.882 100 71.807 100zM69.527 52.424c10.924 0 19.78-8.91 19.78-19.902S80.452 12.62 69.528 12.62c-10.925 0-19.78 8.91-19.78 19.902 0 10.991 8.855 19.902 19.78 19.902zM27.867 78.941c10.924 0 19.78-8.91 19.78-19.902 0-10.991-8.856-19.902-19.78-19.902-10.925 0-19.781 8.91-19.781 19.902s8.856 19.902 19.78 19.902z"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.541 15.276L25.914 27.023h56.38v56.726l10.627-11.747V15.276h-56.38z",
    fill: "#F9D128"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bigGift_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 15,
    width: 68,
    height: 69
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.541 15.276L25.914 27.023h56.38v56.726l10.627-11.747V15.276h-56.38z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bigGift_svg__b)",
    fill: "#FFEC9B"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.529 52.424c10.924 0 19.78-8.91 19.78-19.902 0-10.991-8.856-19.902-19.78-19.902-10.925 0-19.781 8.91-19.781 19.902s8.856 19.902 19.78 19.902zM71.812 100c10.925 0 19.78-8.91 19.78-19.902s-8.855-19.902-19.78-19.902-19.78 8.91-19.78 19.902S60.886 100 71.811 100z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.756 50.017s2.506-4.16 5.976 0M64.974 46.845s-5-4.459-8.152-.53M40.994 46.845s5-4.459 8.152-.53M57.662 50.017s2.588-3.728 6.076.256",
    stroke: "#333",
    strokeWidth: 1.083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.112 53.245c.815 1.942-1.892 5.06-5.457 5.06-4.201 0-6.28-3.118-5.456-5.06.813-1.917 2.427.308 5.44.308 3.011 0 4.665-2.231 5.471-.308h.002z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bigGift_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 52,
    width: 12,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.112 53.245c.815 1.942-1.892 5.06-5.457 5.06-4.201 0-6.28-3.118-5.456-5.06.813-1.917 2.427.308 5.44.308 3.011 0 4.665-2.231 5.471-.308h.002z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bigGift_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.973 64.993c2.861 0 5.18-2.334 5.18-5.212 0-2.879-2.319-5.212-5.18-5.212-2.86 0-5.18 2.333-5.18 5.212 0 2.878 2.32 5.212 5.18 5.212z",
    fill: "#FF755F"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.294 70.023v-43H69.527",
    stroke: "#333",
    strokeWidth: 1.083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.11 23.752c2.41-.395 4.729-1.37 6.735-2.772 2.007-1.401 3.769-3.252 5.04-5.387a16.234 16.234 0 001.543-3.442c.449-1.44.631-3.012-.025-4.417-.581-1.243-1.826-2.08-3.214-1.969-1.387.112-2.705.983-3.785 1.907-2.059 1.76-3.63 4.081-4.55 6.635-.114.315-.216.633-.308.954a.55.55 0 00.376.666c.296.08.566-.1.662-.379 1.03-2.975 2.082-6.13 1.556-9.32-.384-2.326-1.846-4.704-4.025-5.714-1.138-.527-2.404-.664-3.62-.341-1.217.322-2.287 1.042-3.103 1.97-1.907 2.168-2.181 5.195-1.42 7.904.818 2.91 2.727 5.318 4.71 7.522.248.276.5.549.749.823.472.513 1.23-.255.762-.767-1.837-2-3.753-4.106-4.776-6.67-.932-2.333-1.193-5.138.21-7.342a5.772 5.772 0 012.419-2.137 4.154 4.154 0 013.014-.216c1.997.606 3.388 2.592 3.9 4.584.804 3.124-.391 6.465-1.414 9.417l1.038.287a14.775 14.775 0 013.734-6.328c1.36-1.36 4.351-3.775 5.915-1.372.717 1.102.596 2.455.257 3.67a14.411 14.411 0 01-1.326 3.162 16.277 16.277 0 01-4.409 5.034c-2.045 1.53-4.414 2.579-6.934 2.992-.287.046-.447.405-.376.666.085.307.374.425.662.378l.002.002z",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.914 27.022h20.552M92.922 15.276l-5.315 5.873",
    stroke: "#333",
    strokeWidth: 1.083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.337 52.968c2.872 1.983 5.17 4.76 6.648 7.93 1.573 3.37 2.118 7.195 1.617 10.88a19.8 19.8 0 01-1.917 6.21c-.13.26-.069.587.194.741.24.141.605.068.737-.195a21.028 21.028 0 002.1-11.854c-.45-3.801-1.956-7.382-4.304-10.39a20.556 20.556 0 00-4.53-4.258c-.24-.166-.597-.044-.737.195-.155.268-.048.575.194.741h-.002zM56.525 22.476c-.77-1.39-2.137-2.289-3.613-2.774-1.728-.569-3.574-.515-5.366-.415-1.792.1-3.526.244-5.245-.173-1.29-.313-3.018-1.05-3.36-2.49-.061-.263-.06-.524.104-.742.128-.17.3-.23.498-.231.039 0 .204.015.137.004.065.01.13.027.194.046.036.011.072.023.109.037.088.034-.056-.028.029.015.076.038.153.081.222.133-.05-.037.075.068.088.083.027.027.054.054.08.083.059.072-.034-.05.02.027.094.137.15.288.18.452.123.654-.245 1.341-.715 1.785-.47.444-1.136.722-1.802.827-3.394.532-5.819-2.84-8.087-4.819-1.331-1.162-2.835-2.063-4.585-2.395-1.646-.31-3.384-.191-4.952.417a9.177 9.177 0 00-1.182.556c-.604.34-.061 1.276.543.934 1.481-.836 3.227-1.15 4.91-.928 1.683.222 3.256 1.079 4.568 2.235 1.4 1.233 2.627 2.66 4.162 3.733 1.444 1.01 3.144 1.599 4.91 1.307 1.645-.27 3.232-1.525 3.32-3.303.043-.837-.362-1.66-1.112-2.054-.678-.355-1.52-.372-2.132.13-.672.552-.74 1.505-.443 2.274.324.834.94 1.45 1.673 1.938 1.456.969 3.27 1.272 4.986 1.303 2.065.036 4.125-.311 6.188-.108 1.479.146 3.048.68 4.106 1.781.253.263.46.553.636.873.338.608 1.267.064.93-.546l.001.005zM56.632 23.754c.177 1.135-.265 2.39-1.069 3.249-.406.434-.907.788-1.458.979-.788.272-1.629.318-2.448.44-.82.121-1.563.355-2.275.755s-1.29.872-1.861 1.397c-1.132 1.04-2.105 2.28-3.375 3.156-1.27.877-2.955 1.38-4.323.506-.587-.374-1.126.562-.543.934 1.397.892 3.189.688 4.612-.029 1.507-.756 2.635-2.075 3.81-3.246.553-.55 1.13-1.087 1.783-1.518a5.72 5.72 0 012.241-.878c.862-.145 1.746-.176 2.583-.446a4.81 4.81 0 001.874-1.14 5.15 5.15 0 001.485-4.446c-.046-.29-.405-.45-.662-.379-.307.085-.42.377-.376.666h.002z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bigGift_svg__clip0_2637_11251"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h97.385v100H0z"
  })))));
}
export default __webpack_public_path__ + "static/bigGift.adc0c530.svg";
export { SvgBigGift as ReactComponent };